import _ from 'lodash';
import { translate } from '../../../../scripts/core/tools/translate';
import api from '../../../../scripts/api';
import environment from '../../../../scripts/environment';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class BrownfieldFilterFactory {
    constructor ({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData () {
        const data = [];

        data.push({
            name: 'action',
            position: 1,
            visible: isAuthorized(FeaturePermission.LAYER_BROWNFIELD.filterType),
            fields: [{
                title: translate('Brownfield.Action'),
                name: 'IdAction',
                dataSource: _.map(environment.get('CONFIG.FILTERS.BROWNFIELD_ACTIONS'), a => ({
                    text: a.name,
                    value: a.id
                })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        data.push({
            name: 'storeType',
            position: 2,
            visible: isAuthorized(FeaturePermission.LAYER_BROWNFIELD.filterType),
            fields: [{
                title: translate('Greenfield.StoreType'),
                name: 'IdPointType',
                dataSource: _.map(environment.get('CONFIG.FILTERS.GREENFIELD_POINT_TYPES'), t => ({
                    text: t.name,
                    value: t.id
                })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/brownfield.factory.js